import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import { AssetsContextProvider } from './contexts/assets';
import { BrowserRouter } from 'react-router-dom';
import { AlertContextProvider } from './contexts/alert';
import { Web3ContextProvider } from './contexts/web3';
import { UserDataContextProvider } from './contexts/userData';
import { CreamContextProvider } from './contexts/cream';
import { InitFightProvider } from './contexts/initFight';
import App from './App';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AssetsContextProvider>
    <BrowserRouter>
      <AlertContextProvider>
        <Web3ContextProvider>
          <UserDataContextProvider>
            <CreamContextProvider>
              <InitFightProvider>
                <App />
              </InitFightProvider>
            </CreamContextProvider>
          </UserDataContextProvider>
        </Web3ContextProvider>
      </AlertContextProvider>
    </BrowserRouter>
  </AssetsContextProvider>
);
